import React from "react";

const SliderButton = (props) => {
  const { customFunc, value, type } = props;
  return (
    <label className="inline-flex items-center cursor-pointer ml-2">
      {(type === "notification" || !type) && (
        <input
          type="checkbox"
          className="sr-only peer"
          checked={value}
          onChange={customFunc}
        />
      )}
      {type === "tenantView" && (
        <input
          type="checkbox"
          className="sr-only peer"
          checked={value === "tenant" ? true : false}
          // checked={value}
          onChange={customFunc}
        />
      )}
      <div
        className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none
              peer-focus:ring-2 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800
              rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full
              rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white
              after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white
               after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5
               after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"
      ></div>
    </label>
  );
};

export default SliderButton;
